var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_vm._l((_vm.tieBreakerPresetTooltips[_vm.value]),function(rule,index){return [(rule.trim())?_c('li',{key:(rule + "_" + index),staticClass:"font-size-sm"},[_vm._v("\n      "+_vm._s(rule)+"\n    ")]):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }